var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopied = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_149_6495",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 15,
  height: 14
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.201904,
  width: 14,
  height: 14,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_149_6495)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.47865 12.6323C2.70731 12.8606 2.98206 12.9747 3.3029 12.9747H9.71956V11.808H3.3029V3.64138H2.13623V11.808C2.13623 12.1289 2.25037 12.4036 2.47865 12.6323ZM4.81256 10.299C5.04084 10.5272 5.3154 10.6414 5.63623 10.6414H10.8862C11.2071 10.6414 11.4818 10.5272 11.7105 10.299C11.9388 10.0703 12.0529 9.79554 12.0529 9.47471V2.47471C12.0529 2.15388 11.9388 1.87913 11.7105 1.65046C11.4818 1.42218 11.2071 1.30804 10.8862 1.30804H5.63623C5.3154 1.30804 5.04084 1.42218 4.81256 1.65046C4.5839 1.87913 4.46956 2.15388 4.46956 2.47471V9.47471C4.46956 9.79554 4.5839 10.0703 4.81256 10.299ZM6.51422 5.71062L6.1015 6.12333L7.75236 7.77419L10.8224 4.70417L10.4097 4.29146L7.75236 6.94876L6.51422 5.71062Z",
  fill: "#157F5F"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopied);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/copied.03b02159b035ec15924e828fe1dfea6c.svg";